module.exports = __webpack_public_path__ + "static/shower-11ae59ee765ae3a0188ed542433dfe45.jpg";